export const HOME_COPY = {
  newbie: {
    eyebrow: 'CAPTAIN COOK',
    title: 'You want to cook. We make dinner feel doable.',
    body: 'Keep the recipes you already love in one place. Prefer dinners that lean on what’s already in the pantry and fridge — so the store run stays small. Want something you’re short on? We’ll highlight what’s missing so the trip stays quick and focused.',
    trust: 'Free to use. No credit card.',
  },
  expired: {
    title: 'Time for a fresh start',
    body: 'Create an account and your pantry, recipes, plan, and preferences stay with you whenever you come back.',
  },
  howTitle: 'How it works',
  howLead: 'From scattered recipes to a few dinners and a focused shop — using what you have when you can, and naming what’s missing when you can’t.',
  /** Hero demo stage — placeholder until animation/video ships. */
  demo: {
    label: 'From swirl to a simple week',
    placeholder: 'Short demo coming soon',
    hint: 'Recipes come together, dinners land on the week, and anything missing becomes a short list.',
    beats: [
      ['1', 'Recipes'],
      ['2', 'Dinners'],
      ['3', 'Plan'],
      ['4', 'Shop'],
    ],
  },
  benefitsHeading: 'What you get',
  benefits: [
    ['Your recipes, in one place', 'The ones you already love — not another endless feed'],
    ['Dinners that lean on what you have', 'Prioritize easy nights from the pantry and fridge — without locking you in'],
    ['A focused shop when you’re short', 'Missing items, highlighted. Buy only what that dinner still needs.'],
    ['Help from the Captain', 'Ask when you get stuck — after the kitchen is yours'],
  ],
  steps: [
    ['1', 'Pantry', 'Add what’s in the pantry, fridge, and freezer.'],
    ['2', 'Recipes', 'Bring in recipes you already love.'],
    ['3', 'Plan', 'Put dinners on the week — favoring what you can cook sooner.'],
    ['4', 'Shop', 'See what’s missing and get a short, focused list.'],
  ],
  assurances: [
    ['fa-home', 'Keep your kitchen', 'Save an account so recipes, pantry, and plan stay with you.'],
    ['fa-shield-alt', 'Free to use', 'No credit card.'],
    ['fa-download', 'Bring your own recipes', 'A doc, saved posts, a cookbook photo — import on day one.'],
  ],
}

/** One line under the returning login form. Tonight wins; otherwise last week's counts. */
export function returningMemoryLine(snapshot) {
  const tonight = snapshot?.tonightTitle?.trim()
  if (tonight) return `Tonight was ${tonight}.`
  const planned = Number(snapshot?.planned) || 0
  const cooked = Number(snapshot?.cooked) || 0
  if (planned > 0 || cooked > 0) {
    return `Last week: ${planned} planned, ${cooked} cooked.`
  }
  return ''
}

export const GUEST_COPY = {
  setup: 'Setting up your kitchen. A few dinners from the recipes you love.',
  strip: 'Create an account to keep your recipes, pantry, and plan.',
  offline: 'You’re offline. Reconnect to keep editing or save your kitchen.',
  saveError: 'Couldn’t save your last change. Your kitchen is still here.',
}
